import React, { useState, useEffect, createContext, useContext, ReactNode } from "react"

type isMobileContextType = {
  isMobile: boolean;
  isMobileSm: boolean;
}

const IsMobileContext = createContext<isMobileContextType | undefined>(undefined)

export const useIsMobile = () => {
  const context = useContext(IsMobileContext)
  if (!context) {
    throw new Error("useIsMobile must be used within an IsMobileProvider")
  }
  return context
}

type isMobileProviderProps = {
  children: ReactNode;
}

export const IsMobileProvider: React.FC<isMobileProviderProps> = ({ children }) => {
  const [isMobile, setIsMobile] = useState(false)
  const [isMobileSm, setIsMobileSm] = useState(false)

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 992)
      setIsMobileSm(window.innerWidth < 768)
    }

    // Initial call
    handleResize()

    // Event listener for window resize
    window.addEventListener("resize", handleResize)

    // Cleanup
    return () => {
      window.removeEventListener("resize", handleResize)
    }
  }, [])

  return (
    <IsMobileContext.Provider value={{ isMobile, isMobileSm }}>
      {children}
    </IsMobileContext.Provider>
  )
}
